import type { Gradient } from '@jouzen/ecom-components';

const CLASS_NAME = 'hidden lg:block';

export const whyOuraGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-1',
    position: [90, 15],
    opacity: 0.7,
    size: 10,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D8A78C',
    id: 'orange-2',
    position: [70, 24],
    opacity: 0.4,
    size: 10,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D8A78C',
    id: 'orange-3',
    position: [10, 30],
    opacity: 0.4,
    size: 12,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-4',
    position: [90, 37],
    opacity: 0.7,
    size: 10,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D4D9DD',
    id: 'blue-1',
    position: [90, 62],
    opacity: 1,
    size: 10,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D4D9DD',
    id: 'blue-2',
    position: [50, 61],
    opacity: 1,
    size: 10,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D4D9DD',
    id: 'blue-3',
    position: [10, 65],
    opacity: 1,
    size: 10,
    className: CLASS_NAME,
  },
];
